import UploadRegimeProofError from './UploadRegimeProofError';
class RegimeProofIsOversized extends UploadRegimeProofError {
    constructor(options) {
        super('Fiscal Regime proof is oversized', options);
    }
}
export default RegimeProofIsOversized;
